export default "{\n    \"startTyping\": \"Start typing to search work orders\",\n    \"noResults\": \"No work orders found\"\n}\n"